import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ThirdwebProvider } from "thirdweb/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import store from "./store";
import Wrapper from "./Component/wrapper";
import "./index.css";

const queryClient = new QueryClient();

// Type assertion for null check since getElementById might return null
const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThirdwebProvider>
        <Provider store={store}>
          <Wrapper>
            <App />
          </Wrapper>
        </Provider>
      </ThirdwebProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
